import { type FlyoutProps } from "../../utils/flyout-props";
import { SearchContent } from "./SearchContent/SearchContent";
import { FlyoutSearchStateProvider } from "./SearchContextProvider/context-flyout-search-provider";

export function FlyoutSearch({ screen }: FlyoutProps) {
  return (
    <div className="relative h-full w-full">
      <FlyoutSearchStateProvider screen={screen}>
        <SearchContent />
      </FlyoutSearchStateProvider>
    </div>
  );
}
